import useKeyboardListener from "@/common/hooks/useKeyboardListener";
import useAudioAdapter from "@/common/hooks/useAudioAdapter.ts";
import useAudioVolume from "@/common/hooks/preferences/useAudioVolume.ts";
import useAudioMuted from "@/common/hooks/preferences/useAudioMuted.ts";
import { preventDefaultStopPropagation, safeVolume } from "@/utils/utils.ts";
import { EventTypes } from "@/types/types.ts";
import { emitEvent } from "@/services/event-emitter.ts";

function useKeyboardShortcutVolumeControl(volumeStep: number = 0.2) {
  const [audioAdapter] = useAudioAdapter();
  const [audioVolumeCookie, setAudioVolumeCookie] = useAudioVolume();
  const [audioMutedCookie, setAudioMutedCookie] = useAudioMuted();

  useKeyboardListener((event) => {
    if (!audioAdapter) return;

    if (event.altKey) {
      if (event.key === "µ") { // = m
        event.preventDefault();
        setAudioMutedCookie(!audioMutedCookie);
        audioAdapter.setMuted(!audioMutedCookie);
      }

      let newVolume = null;
      if (event.key === "ArrowUp") {
        newVolume = safeVolume(audioVolumeCookie + volumeStep);
      } else if (event.key === "ArrowDown") {
        preventDefaultStopPropagation(event)
        newVolume = safeVolume(audioVolumeCookie - volumeStep);
      }
      if (newVolume === null) {
        return;
      }

      setAudioVolumeCookie(newVolume);
      audioAdapter.setVolume(newVolume);

      if (newVolume > 0) {
        setAudioMutedCookie(false);
        audioAdapter.setMuted(false);
      } else {
        audioAdapter.setMuted(true);
        setAudioMutedCookie(true);
      }

      emitEvent(EventTypes.UPDATE_AUDIO_VOLUME_SLIDER, newVolume);
    }
  });

  return null;
}

export default useKeyboardShortcutVolumeControl;
